export function areIdsEqual(left: unknown, right: unknown): boolean {
  if(left == null || right == null) {
    return false
  }
  return String(left) === String(right)
}
